var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/greenCheck.bd83e513.png","uri@2x": __webpack_public_path__ + "static/media/greenCheck.bd9c73c6.png","uri@3x": __webpack_public_path__ + "static/media/greenCheck.c0a38997.png",
    width: 16,
    height: 16
});